import { ReviewSessionContext, useCreateReviewSession } from "@components/QaReview/hooks/useReviewSession";
import { useReportOptional } from "@providers/ReportProvider";

export const ReviewSessionProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const reportId = useReportOptional()?.report?.id;
  return <ReviewSessionContext value={useCreateReviewSession(reportId)}>{children}</ReviewSessionContext>;
};
